import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Paper, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@mui/material';
import { coreService } from '../services/coreService';

export default function CoreSettingsPage() {
  const [tab, setTab] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let result = [];
      if (tab === 0) result = await coreService.offices.getAll();
      else if (tab === 1) result = await coreService.departments.getAll();
      else if (tab === 2) result = await coreService.negotiators.getAll();
      else if (tab === 3) result = await coreService.companies.getAll();
      
      setData(Array.isArray(result) ? result : result.results || []);
    } catch (e) {
      console.error(e);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [tab]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, minHeight: '100vh', background: '#F4F6FB' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#1A1A2E' }}>Core Settings</Typography>
        <Typography variant="body2" sx={{ color: '#888', mt: 0.5 }}>Manage offices, departments, negotiators, and companies.</Typography>
      </Box>

      <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid #E8EAF0', overflow: 'hidden' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: '1px solid #E0E0E0', px: 2 }}>
          <Tab label="Offices" />
          <Tab label="Departments" />
          <Tab label="Negotiators" />
          <Tab label="Companies" />
        </Tabs>
        
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ background: '#F8F5FF' }}>
                <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={2} align="center"><CircularProgress size={24}/></TableCell></TableRow>
              ) : data.length === 0 ? (
                <TableRow><TableCell colSpan={2} align="center">No data found</TableCell></TableRow>
              ) : (
                data.map((item) => (
                  <TableRow key={item.id} hover>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.name || item.company_name || `${item.forename} ${item.surname}`}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
